import { MotifTextArea } from '@ey-xd/motif-react';
import './TextArea.scss';

type TextAreaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    value: string;
    label?: string;
    className?: string;
    errorMessage?: string;
};
const TextArea: React.FC<TextAreaProps> = ({ className, ...other }: TextAreaProps) => {
    return (
        <MotifTextArea
            {...other}
            data-testId={'test-textarea'}
            className={`text-area override ${className}`}
        />
    );
};

export default TextArea;
